import React from 'react';
import TeamMemberListItem from "./TeamMemberListItem.mjs";

export default function TeamMemberList({team_members_list}) 
{
    if (!team_members_list) return;
    
    return (
        <>
            <ol class="list-group">
                { team_members_list?.map( (member, i) => ( <TeamMemberListItem member={member} key={i} ndx={i} /> )) }
            </ol>
        </>
    );
}